import React from 'react';
import { Modal, ModalHeader } from 'reactstrap';
import WaterUseStatusForm from '../Forms/WaterUseStatusForm';

const AddEditWaterUseStatusModal = ({
	dataWaterUseStatus,
	isOpen,
	isEdit,
	handleToggleModal,
	activeTab,
	toggleTab,
	toggleRefetch,
}) => {
	return (
		<Modal
			isOpen={isOpen}
			toggle={handleToggleModal}
			size='xs'
			className='border-0'
			modalClassName='modal fade zoomIn'
			backdrop={'static'}
			centered={true}
		>
			<ModalHeader toggle={handleToggleModal}>
				{isEdit ? 'Editar' : 'Agregar'} Estado de Uso
			</ModalHeader>

			<WaterUseStatusForm
				dataWaterUseStatus={dataWaterUseStatus}
				isOpen={isOpen}
				isEdit={isEdit}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
				toggleRefetch={toggleRefetch}
			/>
		</Modal>
	);
};

export default AddEditWaterUseStatusModal;
